import { Customer } from "../../../data/entities";

type CustomerContactList = Customer["contact_list"];

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === "object" && value !== null && !Array.isArray(value);

export const normalizeCustomerContactList = (
    contactList: unknown,
): CustomerContactList => {
    if (!Array.isArray(contactList)) return [];

    return contactList
        .filter(
            (item) => isRecord(item) && isRecord(item.contact),
        )
        .map((item) => ({
            ...item,
            contact: {
                ...item.contact,
            },
        })) as CustomerContactList;
};

export const normalizeCustomerData = (
    customerData: unknown,
): Customer => {
    const customer = isRecord(customerData) ? customerData : {};

    return {
        ...customer,
        contact_list: normalizeCustomerContactList(customer.contact_list),
        delivery_addresses: Array.isArray(customer.delivery_addresses)
            ? customer.delivery_addresses.filter(isRecord).map((address) => ({
                ...address,
                is_default: address.is_default === true,
            }))
            : [],
    } as Customer;
};

export const mergeCustomerResponse = (
    currentCustomer: Customer,
    responseData: unknown,
): Customer =>
    normalizeCustomerData({
        ...currentCustomer,
        ...(isRecord(responseData) ? responseData : {}),
    });
